/** The largest master the app uploads (music24-api `MAX_MASTER_BYTES`). */
export const MAX_MASTER_MB = 200;
const MAX_MASTER_BYTES = MAX_MASTER_MB * 1024 * 1024;

const MASTER_EXTENSIONS = ['wav', 'flac', 'aif', 'aiff', 'mp3', 'm4a', 'aac'];
const MASTER_MIME_TYPES = [
  'audio/wav',
  'audio/x-wav',
  'audio/wave',
  'audio/flac',
  'audio/x-flac',
  'audio/aiff',
  'audio/x-aiff',
  'audio/mpeg',
  'audio/mp3',
  'audio/mp4',
  'audio/x-m4a',
  'audio/aac',
];

/** The `accept` of the file input. */
export const MASTER_ACCEPT = [...MASTER_MIME_TYPES, ...MASTER_EXTENSIONS.map((ext) => `.${ext}`)].join(',');

export type MasterFileProblem = 'tooBig' | 'wrongType';

/** Checks a picked or dropped master before the upload. Null means the file is good. */
export function checkMasterFile(file: Pick<File, 'name' | 'type' | 'size'>): MasterFileProblem | null {
  const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!MASTER_EXTENSIONS.includes(extension) && !MASTER_MIME_TYPES.includes(file.type)) {
    return 'wrongType';
  }
  if (file.size > MAX_MASTER_BYTES) {
    return 'tooBig';
  }
  return null;
}

/** `m:ss` for a song length in seconds. */
export function formatSongLength(seconds: number): string {
  const whole = Math.round(seconds);
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
}
